// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3awpr","label":"styles_label__3VlCd"};